import _ from 'underscore';

export const selectionStatePlugin = definePlugin => definePlugin('selectionState', [
  'gridView',
  'crossPageSelectAll',
], (gridView, crossPageSelectAll) => {
  let selectedKeys = [];
  const { primaryKey } = gridView;

  function setSelectedKeys(keys) {
    let { selected } = gridView.get('selection');

    const rowsToSelect = _.difference(keys, selected);
    const rowsToDeselect = _.difference(selected, keys);

    _.each(rowsToSelect, (id) => {
      const { resolver } = gridView.get('selection');
      const selection = resolver.selectRow(id);
      gridView.set({ selection });
    });

    _.each(rowsToDeselect, (id) => {
      const { resolver } = gridView.get('selection');
      const selection = resolver.deselectRow(id);
      gridView.set({ selection });
    });

    selected = gridView.get('selection').selected; // eslint-disable-line prefer-destructuring
    gridView.trigger('didSelect', selected);
  }

  gridView.on('didSelect', (selections) => {
    if (_.size(selections) === gridView.countRows && crossPageSelectAll.isAllSelected) {
      selectedKeys = [];
    } else {
      selectedKeys = selections;
    }
  });

  gridView.on('didReload', (success, { totalCount, items }) => {
    if (success && totalCount > 0 && !crossPageSelectAll.isAllSelected) {
      const keysAfterReload = _.map(items, item => item[primaryKey].toString());
      selectedKeys = _.intersection(selectedKeys, keysAfterReload);

      gridView.once('didUpdate', () => {
        setSelectedKeys(selectedKeys);
      });
    }
  });
});
